/**
 * Brand Component-Token Overrides (Abyss v2 — PERMANENT)
 *
 * Intentional brand customizations that override Abyss v2 *component tokens*
 * with EEMS brand colors. This is the recommended v2 way to brand components
 * (per the token-migration guide, Phase 5 "Category 3: Intentional Overrides"):
 * customize component tokens in `createTheme` so Abyss emits the brand value as
 * the native CSS variable — no wrapper selectors or specificity/`!important`
 * hacks.
 *
 * This file is kept after migration because it represents deliberate design
 * decisions, not migration debt.
 *
 * Merged into the theme in browser.tsx. Each key matches a base component token
 * in `@uhg-abyss/web/tools/theme/variants/componentTokens.js`, so the value is
 * overridden (not duplicated). Values use v2 semantic token references so they
 * stay tied to the brand palette without the temporary legacy-token shim.
 */

const brandOverrides = {
  colors: {
    // Top-level nav bar: blue bar, white links, white hover surface.
    'nav-menu.color.surface.container.header':
      '$web.semantic.color.surface.container.primary',
    'nav-menu.color.text.interactive.header.rest.default':
      '$web.semantic.color.text.content.primary-alt',
    'nav-menu.color.text.interactive.header.hover.default':
      '$web.semantic.color.text.content.primary',
    'nav-menu.color.surface.interactive.header.rest.default': 'transparent',
    'nav-menu.color.surface.interactive.header.hover.default':
      '$web.semantic.color.surface.container.secondary',

    // v2 DataTable column headers: blue background, white text.
    'data-table.color.surface.column-header.default':
      '$web.semantic.color.surface.container.primary',
    'data-table.color.text.column-header':
      '$web.semantic.color.text.content.primary-alt',

    // Banner header container: restore the v1 white background.
    'header.color.surface.header-container':
      '$web.semantic.color.surface.container.secondary',
  },
};

export default brandOverrides;
